import React from 'react';
import { Button } from './ui/button';
import { Shield, ArrowRight } from 'lucide-react';

const HeroSection = ({ openPopup }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" id="home">
      <div className="hero-overlay"></div>
      <div className="hero-image-wrapper">
        <img 
          src="https://images.unsplash.com/photo-1775046318523-b5227f41fe97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxsZWdhbCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzU1MTQ0MDF8MA&ixlib=rb-4.1.0&q=85" 
          alt="Professional legal services"
          className="hero-image"
        />
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Shield size={20} />
            <span>USPTO Filing Experts Since 2010</span>
          </div>
          
          <h1 className="hero-title">
            Protect Your Brand with
            <span className="hero-title-highlight"> Professional Trademark Registration</span>
          </h1>
          
          <p className="hero-description">
            Secure your business identity with expert trademark registration services. 
            From comprehensive searches to USPTO filing and ongoing monitoring, we safeguard 
            your brand's future with proven legal expertise and a 98% success rate.
          </p>

          <div className="hero-features">
            <div className="hero-feature-item">
              <div className="hero-feature-icon">✓</div>
              <span>1000+ Trademarks Successfully Registered</span>
            </div>
            <div className="hero-feature-item">
              <div className="hero-feature-icon">✓</div>
              <span>98% USPTO Approval Success Rate</span>
            </div>
            <div className="hero-feature-item">
              <div className="hero-feature-icon">✓</div>
              <span>Expert Legal Team & Dedicated Case Managers</span>
            </div>
          </div>

          <div className="hero-cta-group">
            <Button onClick={openPopup} className="hero-cta-primary" size="lg">
              Register My Trademark
              <ArrowRight size={20} />
            </Button>
            <Button 
              onClick={() => scrollToSection('services')} 
              variant="outline" 
              className="hero-cta-secondary" 
              size="lg"
            >
              Explore Services
            </Button>
          </div>

          <div className="hero-trust-bar">
            <div className="trust-item">
              <strong>15+</strong>
              <span>Years Experience</span>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <strong>1000+</strong>
              <span>Brands Protected</span>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <strong>All 50</strong>
              <span>States Served</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
